import * as React from "react";
import type { QuickJournalTheme } from "../QuickJournalTheme";
import { QuickJournalCyberpunkAmbientMotion } from "./QuickJournalCyberpunkAmbientMotion";
import { QuickJournalNightLakeShips } from "./QuickJournalNightLakeShips";
import { QuickJournalDuneHeatMirage } from "./QuickJournalDuneHeatMirage";
import { QuickJournalChromaFlare } from "./QuickJournalChromaFlare";

export function QuickJournalLowerAmbience({ theme, isPaused }: { theme: QuickJournalTheme; isPaused: boolean }) {
    switch (theme.id) {
        case "cyberpunk": return <QuickJournalCyberpunkAmbientMotion isPaused={isPaused} />;
        case "night": return <QuickJournalNightLakeShips isPaused={isPaused} />;
        case "dune": return <QuickJournalDuneHeatMirage isPaused={isPaused} />;
        case "chromaflare": return <QuickJournalChromaFlare isPaused={isPaused} />;
    }
}
